import { render, staticRenderFns } from "./g-select.vue?vue&type=template&id=2eef8f18&"
import script from "./g-select.vue?vue&type=script&lang=js&"
export * from "./g-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports